<template>
  <div class="workspace__container__view">
    <div class="workspace__container__view__header column">
      <div class="workspace__container__view__header__filter">
        <div class="container__column">
          <div class="container__inputs">
            <div class="settings-input">
              <label for="">{{ $t('workspace.certificate.station') }}</label>
              <Multiselect
              v-model="filterModel.stationId"
              :placeholder="$t('workspace.certificate.all_station')"
              :searchable="false"
              track-by="name"
              valueProp="id"
              label="name"
              :options="listStations"
              :style="{'color': !filterModel.stationId ? '#757575' : '#ffffffde'}" 
              @select="search(true)" @clear="search(true)" />

              <!-- <select v-model="filterModel.stationId" @change="search(true)" :style="{'color': !filterModel.stationId ? '#757575' : '#ffffffde'}">
                <option :value="null">{{$t('workspace.certificate.all_station')}}</option>
                <option v-for="station in listStations" :value="station.id" :key="station.id">{{station.name}}</option>
              </select> -->
            </div>
            <div class="settings-input">
              <label for="">{{ $t('workspace.certificate.agency') }}</label>
              <Multiselect
                v-model="filterModel.adAgencyId"
                :placeholder="$t('workspace.certificate.all_agency')"
                track-by="customLabel"
                valueProp="id"
                label="customLabel"
                :searchable="true"
                :options="listAgencies" 
                @select="search(true)" @clear="search(true)" />
 
              <!-- <select v-model="filterModel.adAgencyId" @change="search(true)">
                <option :value="null">{{$t('workspace.certificate.all_agency')}}</option>
                <option v-for="agency in listAgencies" :value="agency.id" :key="agency.id">{{agency.code}} - {{agency.name}}</option>
              </select> -->
            </div>
            <div class="settings-input">
              <label for="">{{ $t('workspace.certificate.customer') }}</label>
              <Multiselect
                v-model="filterModel.clientId"
                :placeholder="$t('workspace.certificate.all_customer')"
                track-by="customLabel"
                valueProp="id"
                label="customLabel"
                :searchable="true"
                :options="listClients" 
                @select="search(true)" @clear="search(true)" />

              <!-- <select v-model="filterModel.clientId" @change="search(true)">
                <option :value="null">{{$t('workspace.certificate.all_customer')}}</option>
                <option v-for="customer in listClients" :value="customer.id" :key="customer.id">{{customer.code}} - {{customer.name}}</option>
              </select> -->
            </div>
            <div class="settings-input tooltip-search">
              <label for="">{{ $t('workspace.certificate.name') }}</label>
              <input type="text" v-model="filterModel.name" :placeholder="`${$t('workspace.certificate.all_name')}`" @keypress="editName = true" @keypress.enter="search(true); editName = false; editInternalOrderNumber = false; editAgencyOrderNumber = false">
              <Transition>
                <div v-if="editName && filterModel.name != ''" v-html="$t('workspace.spot.press_enter')"></div>
              </Transition>
            </div>
          </div>
          <div class="container__inputs">
            <div class="settings-input tooltip-search">
              <label for="">{{ $t('workspace.certificate.num_int') }}</label>
              <input type="number" step="1" pattern="[0-9]" v-model="filterModel.internalOrderNumber" @keypress="editInternalOrderNumber = true" @keypress.enter="search(true); editName = false; editInternalOrderNumber = false; editAgencyOrderNumber = false" :placeholder="`${$t('workspace.certificate.all_num_int')}`">
              <Transition>
                <div v-if="editInternalOrderNumber && filterModel.internalOrderNumber != ''" v-html="$t('workspace.spot.press_enter')"></div>
              </Transition>
            </div>
            <div class="settings-input tooltip-search">
              <label for="">{{ $t('workspace.certificate.num_agency') }}</label>
              <input type="text" v-model="filterModel.agencyOrderNumber" :placeholder="`${$t('workspace.certificate.all_num_agency')}`" @keypress="editAgencyOrderNumber = true" @keypress.enter="search(true); editName = false; editInternalOrderNumber = false; editAgencyOrderNumber = false">
              <Transition>
                <div v-if="editAgencyOrderNumber && filterModel.agencyOrderNumber != ''" v-html="$t('workspace.spot.press_enter')"></div>
              </Transition>
            </div>
            <div class="settings-input">
              <label for="">{{$t('workspace.certificate.period')}}</label>
              <Multiselect
                v-model="filterModel.period"
                :searchable="false"
                :canDeselect="false"
                :canClear="false"
                :options="[
                  { value: true, label: `${$t('workspace.certificate.period_period')}` },
                  { value: false, label: `${$t('workspace.certificate.period_date-range')}` }
                ]"
                @select="search(true)" @clear="search(true)" />

              <!-- <select v-model="filterModel.period" @change="search(true)">
                <option :value="true">{{$t('workspace.certificate.period_period')}}</option>
                <option :value="false">{{$t('workspace.certificate.period_date-range')}}</option>
              </select> -->
            </div>
            <div class="settings-input" v-if="filterModel.period">
              <label>{{$t('workspace.certificate.month')}}</label>
              <input type="month" v-model="filterModel.month" @change="search(true)">
            </div>
            
            <template v-else>
              <div class="settings-input half-column">
                <label>{{$t('workspace.certificate.dateFrom')}}</label>
                <input type="date" v-model="filterModel.dateFrom" @change="changeDateFrom" :class="{'invalid': datesInvalid}">
              </div>
              
              <div class="settings-input half-column">
                <label>{{$t('workspace.certificate.dateTo')}}</label>
                <input type="date" v-model="filterModel.dateTo" @change="validate" :max="dateFromYear" :class="{'invalid': datesInvalid}">
              </div>
            </template>
          </div>
        </div>
        <button @click="clearFilters" :disabled="disabledCleanFilter">
          <i class="material-icons" style="font-size: 20px">filter_alt_off</i>
        </button>
      </div>
    </div>
    <div class="table-scroll">
      <table class="workspace__container__view__table with-padding">
        <thead>
          <tr>
            <th style="width: 40px"></th>
            <th>{{ $t("workspace.certificate.station") }}</th>
            <th>{{ $t("workspace.certificate.agency") }}</th>
            <th>{{ $t("workspace.certificate.customer") }}</th>
            <th>{{ $t("workspace.certificate.name") }}</th>
            <th>{{ $t("workspace.certificate.init") }}</th>
            <th>{{ $t("workspace.certificate.end") }}</th>
            <th class="float-right">{{ $t("workspace.certificate.num_int") }}</th>
            <th class="float-right">{{ $t("workspace.certificate.num_agency") }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="listSpots.length > 0">  
            <tr v-for="item in listSpots" :key="item.code" :class="{'selected': certifyModel.Spots.includes(item.id)}" @click="toggleSpot(item.id)">
              <td style="width: 40px"><input type="checkbox" :checked="certifyModel.Spots.includes(item.id)" readonly></td>
              <td v-html="item.stationName || '-'"></td>
              <td v-html="item.adAgencyName || '-'"></td>
              <td v-html="item.customerName || '-'"></td>
              <td v-html="item.spotName || '-'"></td>
              <td v-html="formatDate(item.initDate) || '-'"></td>
              <td v-html="formatDate(item.dueDate) || '-'"></td>
              <td class="float-right" v-html="item.internalNumber || '-'"></td>
              <td class="float-right" v-html="item.agencyOrderNumber || '-'"></td>
            </tr>
          </template>
          <tr v-if="listSpots.length == 0">
            <td colspan="9" v-html="$t('workspace.certificate.not_have_results')"></td>
          </tr>
          <tr v-if="(filterModel.pageNumber + 1) * filterModel.rowsPerPage < totalResults">
            <td colspan="9" @click="addPage">
              <strong class="text-load">{{$t('workspace.certificate.more_results')}} <i class="material-icons">keyboard_arrow_down</i></strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="workspace__container__view__actions">
      <button @click="certificate" :class="{'disabled': certifyModel.Spots.length == 0}" :disabled="certifyModel.Spots.length == 0">{{ $t("workspace.certificate.certificate") }}</button>
    </div>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
    const store = useStore();
    const listSpots = ref([]);
    const totalResults = ref(0);
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    const listAgencies = computed(() => store.getters.adAgency_agenciesList);
    const listClients = computed(() => store.getters.client_clientsList);
    const editName = ref(false);
    const editInternalOrderNumber = ref(false);
    const editAgencyOrderNumber = ref(false);
    const disabledCleanFilter = computed(() => {
      const modelClean = {
        stationId: null,
        adAgencyId: null,
        clientId: null,
        name: '',
        agencyOrderNumber: '',
        internalOrderNumber: null,
        period: true,
        month: moment().format("YYYY-MM"),
        dateFrom: moment().format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        pageNumber: 0,
        rowsPerPage: 500
      }
      return JSON.stringify(modelClean) == JSON.stringify(filterModel.value); 
    })
    const filterModel = ref({
      stationId: null,
      adAgencyId: null,
      clientId: null,
      name: '',
      agencyOrderNumber: '',
      internalOrderNumber: null,
      period: true,
      month: moment().format("YYYY-MM"),
      dateFrom: moment().subtract(1, 'month').format("YYYY-MM-DD"),
      dateTo: moment().format("YYYY-MM-DD"),
      pageNumber: 0,
      rowsPerPage: 500
    })

    const certifyModel = ref({
      Spots: [],
      Period: true,
      Year: 0,
      Month: 0,
      DateFrom: '',
      DateTo: ''
    });

    const dateFromYear = computed(() => moment().add(1, 'year').format("YYYY-MM-DD"));
    const datesInvalid = ref(false)

    onMounted(async () => {
      store.dispatch('loading_setActive', true);
      await store.dispatch('station_getAll');
      await store.dispatch('adAgency_getAll');
      await store.dispatch('client_getAll');
      await search();
      store.dispatch('loading_setActive', false);
    });

    async function toggleSpot (id) {
      const index = certifyModel.value.Spots.findIndex(spotId => spotId == id);
      if (index >= 0) {
        certifyModel.value.Spots.splice(index, 1);
      } else {
        certifyModel.value.Spots.push(id);
      }
    }

    async function certificate() {
      store.dispatch('loading_setActive', true);
      try {
        const _filterModel = {...filterModel.value}; 
        certifyModel.value['Period'] = _filterModel.period
        certifyModel.value['Year'] = Number(moment(_filterModel.month, 'YYYY-MM').format('YYYY'))
        certifyModel.value['Month'] = Number(moment(_filterModel.month, 'YYYY-MM').format('MM'))
        certifyModel.value['DateFrom'] = moment(_filterModel.dateFrom, 'YYYY-MM-DD').format()
        certifyModel.value['DateTo'] = moment(_filterModel.dateTo, 'YYYY-MM-DD').format()
        // Download file
        let element = document.createElement('a');
        element.setAttribute('href', `${process.env.VUE_APP_API_URL}/Certify/certify?data=${btoa(JSON.stringify(certifyModel.value))}`);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      } catch (error) {
        console.log(error)
      } finally {
        store.dispatch('loading_setActive', false);
      }
    }

    async function search(clean = false) {
      store.dispatch('loading_setActive', true);
      datesInvalid.value = false;
      if (clean) {
        listSpots.value = [];
        filterModel.value.pageNumber = 0;
      }

      setTimeout(async () => {
        const model = {...filterModel.value};
        if (model.period) {
          delete model.dateFrom;
          delete model.dateTo;
          model.month = moment(model.month, 'YYYY-MM').format()
        } else {
          delete model.month;
          
          if ((moment(model.dateFrom).isBefore('2000-01-01') || moment(model.dateTo).isBefore('2000-01-01')) || 
            moment(model.dateTo).isAfter(moment(model.dateFrom).add(1, 'year')) ||
            moment(model.dateTo).isBefore(moment(model.dateFrom))
          ) {
            datesInvalid.value = true;
            store.dispatch('loading_setActive', false);
            return
          }
        }
  
        if (model.internalOrderNumber == '') model.internalOrderNumber = null;
  
        try {
          const response = await store.dispatch('spots_search4Certify', model);
          listSpots.value = listSpots.value.concat(response.data);
          totalResults.value = response.totalResults;
        } catch (error) {
          console.log(error);
        } finally {
          store.dispatch('loading_setActive', false);
        }
      })
    }

    function validate() {
      if (certifyModel.value.DateFrom != '' && certifyModel.value.DateTo != '') {
        if (moment(certifyModel.value.DateFrom).isAfter(certifyModel.value.DateTo)) {
          certifyModel.value.DateTo = certifyModel.value.DateFrom;
        }
      }
      search(true);
    }

    function changeDateFrom() {
      // Validate
      if (moment(filterModel.value.dateFrom).isBefore('2000-01-01')) return;

      if (filterModel.value.dateFrom != '') {
        filterModel.value.dateTo = moment(filterModel.value.dateFrom).add(1, 'month').format("YYYY-MM-DD");
      }
      validate();
    }

    async function addPage() {
      filterModel.value.pageNumber += 1;
      search(); 
    }

    function formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : '-'
    }

    function clearFilters() {
      filterModel.value = {
        stationId: null,
        adAgencyId: null,
        clientId: null,
        name: '',
        agencyOrderNumber: '',
        internalOrderNumber: null,
        period: true,
        month: moment().format("YYYY-MM"),
        dateFrom: moment().format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        pageNumber: 0,
        rowsPerPage: 500
      }

      search(true);
    }

    return {
      listSpots,
      listStations,
      listAgencies,
      listClients,
      filterModel,
      certifyModel,
      editName,
      editInternalOrderNumber,
      editAgencyOrderNumber,
      disabledCleanFilter,
      toggleSpot,
      certificate,
      validate,
      search,
      addPage,
      totalResults,
      formatDate,
      clearFilters,
      dateFromYear,
      changeDateFrom,
      datesInvalid
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/styles/_variables.scss';

  tr {
    cursor: pointer;
  }

  input[type="checkbox"] {
    appearance: none;
    width: 20px;
    height: 20px;
    background: none;
    border: 1px solid $primary-color;
    border-radius: 2px;
    position: relative;
    flex-shrink: 0;

    &:checked {
      background-color: $primary-color;
      
      &:after {
        content: 'check';
        font-family: 'Material icons';
        font-size: 18px;
        position: absolute;
      }
    }
  }
  .selected {
    background: #372d754f;
  }

  .container__column {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .tooltip-search {
    position: relative;

    div {
      position: absolute;
      width: 100%;
      border-radius: 8px;
      top: -32px;
      text-align: center;
      background: #7763ff;
      color: white;
      padding: 4px 0;
      transition: all .3s;

      :before {
        content:"\A";
        border-style: solid;
        border-width: 15px 10px 0px 10px;
        border-color: #7763ff transparent transparent transparent;
        position: absolute;
        bottom: -8px;
        left: calc(50% - 5px);
      }
    }
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
</style>